<template lang="pug">
  section.looper(v-if="!postsLoading")
    router-link.section-link(v-for="post in posts", :to="post.slug", :key="post.id")
      PostItem(:post="post")
</template>

<script>
import PostItem from '@/components/ironman/PostItem'
export default {
  props: {
    posts: Array,
    postsLoading: Boolean
  },
  components: {
     PostItem
  }
}
</script>
<style lang="scss" scoped>
  .looper{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: $globalgapping;
    @media (max-width: 800px){
      grid-template-columns: 1fr;
    }
  }
</style>



